import { useMultiStepContext } from './MultiStepContext';
import { If } from 'helpers';

export function Step({ name, component }) {
    const { step } = useMultiStepContext();

    return <If condition={step === name}>{component}</If>;
}
